import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const keywords = [
    "iptv smarters pro", "xtream iptv", "code iptv gratuit 2025", "m3u iptv", "iptv boitier",
    "tivimate iptv player", "iptv smart player", "iptv smarters player", "iptv illégal", "iptv amazon stick",
    "iptv amende", "iptv apk gratuit", "iptv alibaba", "iptv amazon code", "abonnement iptv 12 mois smart tv",
    "amende iptv", "aliexpress iptv", "app iptv", "apk iptv smart player", "app iptv android",
    "are iptv legal", "apk xtream iptv", "apk iptv player", "apk hot iptv", "à quoi sert iptv",
    "à contre sens 2 iptv", "à contre sens iptv", "chasse à l iptv", "iptv boitier prix", "iptv boulanger",
    "iptv blocage", "iptv blink player", "iptv box orange", "iptv boitier x96", "iptv bloqué sur boot",
    "boitier iptv", "box iptv", "by iptv apk", "blink iptv player", "belgique amende iptv",
    "by iptv pc", "by iptv iphone", "iptv cle usb", "iptv chromecast gratuit", "iptv code telegram",
    "iptv cdiscount", "iptv classement", "iptv cle amazon", "comment avoir les codes iptv gratuit",
    "code iptv smarters pro gratuit 2025", "code iptv gratuit telegram", "cobra iptv", "canada iptv",
    "code xtream iptv 2025 telegram", "com lynx iptv", "canada best iptv reddit", "com xtream iptv player",
    "iptv ça veut dire quoi", "iptv çöktü mü", "iptv çok donuyor", "iptv çökertildi", "iptv çalışma listesi",
    "iptv çeşitleri", "iptv çalışma mantığı", "iptv çalıştırma programı", "iptv çalışma listesi url",
    "iptv çok internet yer mi", "ça veut dire quoi iptv", "ça iptv", "çakallarla dans 7 iptv",
    "iptv donma sorunu çözümü", "smart iptv çalışmıyor", "iptv neden çalışmıyor", "iptv smarters pro çalışmıyor",
    "next iptv çalışmıyor", "iptv yurt dışında çalışmıyor", "iptv smarters pro türkçeye çevirme",
    "iptv downloader code", "iptv definition", "iptv decodeur", "iptv darty", "iptv dazn",
    "iptv discord", "iptv direct", "iptv download pc", "iptv discord fr", "iptv dream tv",
    "décodeur iptv avec code", "decodeur iptv", "décodeur iptv chaîne gratuite", "dream iptv",
    "dragon iptv", "downloader code iptv", "dream player iptv", "downloader iptv", "daddylive iptv",
    "discord iptv", "iptv extreme", "iptv est ce legal", "iptv extreme pro", "iptv electro depot",
    "iptv espagne", "iptv extreme pro apk", "iptv en france amende", "iptv expert windows",
    "elite iptv", "es iptv pro", "express iptv", "extreme iptv player", "expert iptv",
    "extreme iptv pro", "espana iptv", "iptv électro depot", "iptv écran vert", "iptv élite",
    "iptv é ilegal", "iptv é crime", "iptv é legal", "iptv é legal no brasil", "iptv é pirata",
    "iptv é seguro", "iptv é legal em portugal", "é crime usar iptv", "éditeur m3u iptv download",
    "élite iptv", "é pecado usar iptv", "é assim que acaba filme iptv", "é assim que acaba tem no iptv",
    "électro dépôt iptv", "é ilegal usar iptv", "évanouis iptv", "é crime iptv", "iptv è legale",
    "iptv è illegale", "iptv è sicuro", "iptv è legale in svizzera", "iptv abbonamento è legale",
    "iptv smarters pro è legale", "cos è iptv smarters pro", "iptv extreme è legale", "l iptv è legale",
    "iptv extreme cos'è", "iptv the best è legale", "iptv smarters cosa è", "pezzotto iptv cos'è",
    "iptv smart player cos'è", "iptv in svizzera è legale", "hot iptv cos è", "iptv o que ê",
    "iptv est ce legal en france", "iptv ethernet", "comment empêcher l iptv d être bloqué",
    "l'art d'être heureux iptv", "épée tv", "iptv-", "iptv film", "iptv football", "iptv formuler",
    "iptv fiable reddit", "fox iptv", "formuler iptv", "flex iptv", "free iptv apk", "fast iptv",
    "football iptv", "iptv gratuit android tv", "iptv gratuit pc", "iptv google tv", "iptv gratuit sans code",
    "iptv generator", "iptv gratuit telegram", "gse smart iptv", "gse smart iptv pro apk", "gse iptv apk",
    "gt iptv", "iptv haram", "iptv house", "iptv hdmi", "iptv hdr", "iptv helper", "iptv hors ligne",
    "iptv hadopi", "how is iptv legal", "how to iptv smarters", "how much is iptv box", "iptv interdit en france",
    "iptv infinity", "iptv illegal forum", "iptv illégal avis", "iptv italie", "iptv iphone apk",
    "iptv interface", "iptv isp", "i player iptv", "iptv xtream iptv", "iptv iptv smart player",
    "iptv zen iptv", "ce înseamnă iptv", "île de la tentation espagne iptv", "l'île de la tentation iptv",
    "ıptv", "iptv jellyfin", "iptv japon", "iptv justice", "iptv j'ai le son mais pas l'image",
    "iptv journalsat code", "iptv jeux vidéo", "iptv jellyfin plugin", "iptv jemeppe", "iptv jumia",
    "iptv jean talon", "jellyfin iptv", "justpaste it iptv", "joy iptv", "jellyfin iptv plugin",
    "journalsat iptv code", "jellyfin iptv xtream", "jemeppe iptv", "jailbreak apple tv iptv",
    "iptv japan reddit", "iptv king pro", "iptv king pro apk", "iptv kinguin", "iptv ko",
    "iptv kosova", "iptv korea", "iptv king apk", "king iptv pro", "kyng atlas hd 200s iptv",
    "king iptv 4k apk", "kosova iptv", "iptv legal", "iptv légal france", "iptv legal ou pas",
    "iptv lecteur", "iptv linux", "iptv legal liste", "iptv lite", "iptv live stream", "iptv leclerc",
    "iptv m3u player", "iptv master", "iptv max", "iptv m3u pc gratuit", "iptv molotov", "iptv max pro",
    "iptv mytvonline", "iptv macbook", "meilleur iptv illegal", "mytv iptv", "m3u iptv player",
    "mac iptv player", "iptv ne fonctionne plus bouygues", "iptv nox apk", "iptv ne fonctionne plus sfr",
    "iptv nox pro apk", "iptv net", "iptv network error", "net iptv", "nova iptv", "nextv iptv",
    "nordic iptv", "network error iptv", "neutro iptv player", "net iptv pro", "nettv iptv",
    "next iptv", "iptv orange", "iptv online player", "iptv orange tv", "iptv one", "iptv origine",
    "iptv ott platinum player", "orange iptv", "obs iptv apk", "online iptv player", "opus iptv",
    "one iptv player", "one iptv", "open iptv", "ott navigator iptv code 2025", "octo iptv",
    "online iptv", "öffentliche iptv playlist kostenlos", "öffentliche iptv playlist deutsch",
    "öffentliche iptv liste", "öffentliche iptv playlist sky", "özbeceriksizler iptv",
    "öffentliche iptv", "ömür boyu iptv", "öffentliche iptv playlist österreich",
    "öffentlich rechtliche iptv", "öffentliche iptv playliste", "iptv pro stream player",
    "iptv player gratuit", "iptv pro max", "iptv pour windows", "iptv programme", "iptv pirates avis",
    "pro iptv", "player iptv", "iptvportal", "pc iptv", "player iptv apk", "player iptv windows",
    "player iptv online", "pro iptv smarters", "player xtream iptv", "player smart iptv",
    "iptv qu'est ce que s'est", "iptv qui ne fonctionne plus", "iptv quels risques", "quebec iptv",
    "que veut dire iptv", "quel est le meilleur iptv illegal", "q smart iptv player", "quick player iptv",
    "que significa iptv", "iptv reddit", "iptv risques", "iptv reddit france", "iptv recorder",
    "iptv red by sfr", "iptv raspberry pi", "iptv reel", "iptv raspberry", "reel iptv", "reddit iptv",
    "real iptv", "reddit best iptv", "rapid iptv", "romania iptv", "reddit best iptv provider",
    "reddit best iptv canada", "reddit iptv canada", "reddit firestick iptv", "iptv smart player pro",
    "iptv smarters lite", "iptv smarters player lite", "iptv smarters plus", "iptv smart player apk",
    "smarters iptv pro", "smarters iptv lite", "smarters player lite iptv", "stream iptv player pro",
    "iptv telegram", "iptv tivimate", "iptv telegram 2025", "iptv telecommande", "iptv tcl",
    "télécharger code xtream iptv gratuit", "televizo iptv player", "the iptv smarters pro",
    "iptv ultra", "iptv ubuntu", "iptv url checker", "iptv ultimate", "iptv uno", "iptv utilisateur",
    "iptv usa legal", "uhf iptv", "ultimate iptv", "uno iptv", "ultra iptv", "ultimate iptv loader pro",
    "ultimate iptv loader pro apk", "universal iptv", "un iptv c'est quoi", "un boîtier iptv",
    "un decodeur iptv", "un box iptv", "un iptv gratis", "iptv vpn", "iptv vision",
    "iptv vlc player windows 10", "iptv vu", "iptv via box bouygues", "iptv videoprojecteur",
    "iptv vlan", "iptv voiture", "iptv virus", "vu iptv player", "vu iptv player apk", "vpn iptv",
    "viking iptv", "ventox iptv player", "vavoo iptv", "vu iptv player premium apk", "vision iptv",
    "vu iptv player pro", "vu iptv player windows", "iptv windows gratuit", "iptv wifi",
    "iptv wifi ou ethernet", "iptv windows 10", "iptv wikipedia", "iptv watch", "iptv watch tv online",
    "iptv warez", "what is iptv player", "windows iptv smarters pro", "iptv xtream", "iptv xiaomi",
    "iptv x96", "iptv xtream player", "iptv x96 max plus", "iptv x96q", "iptv xbox series s",
    "iptv xtream pro", "iptv xtream code player", "xtream iptv player", "xtream iptv code 2025 telegram",
    "xc iptv", "xiaomi iptv", "xtream iptv player pc", "xtream codes iptv apk", "xciptv player",
    "xtream iptv smart player", "iptv youtube", "iptv youtube premium", "iptv yacine",
    "iptv y a quoi dessus", "iptv your stb is blocked", "iptv yaoundé", "iptv yassin tv",
    "iptv yıllık ücret ne kadar", "iptv your account is blocked code 7", "yacine player tv m3u iptv",
    "yacine tv iptv", "youtube iptv", "youtube iptv gratuit", "yiptv", "yuki iptv windows",
    "your stb is blocked call the provider iptv", "iptv zen", "iptv z11 pro", "iptv z8 pro",
    "iptv zeop", "iptv z11", "iptv z10 pro", "iptv z8", "iptv zone", "iptv z11 pro max",
    "iptv z10 pro max", "zen iptv", "zen iptv windows", "zen iptv code 2025 echolink",
    "ztv iptv apk", "zodiac iptv", "zen iptv code 2025", "zoom player iptv", "zen iptv mod apk",
    "zen iptv code 2025", "z10 iptv", "iptv 000 player", "iptv 0ro", "0000 iptv", "01net iptv",
    "000 player iptv", "000 player code free iptv", "02 iptv", "0000 player iptv", "000 player iptv apk",
    "0tt navigator iptv", "mtv 00s iptv", "iptv 12 mois - cdiscount", "iptv 2025", "iptv 2025 gratuit",
    "iptv 2025 telegram", "iptv 2025 code", "247 iptv player login", "2025 iptv", "2025 iptv m3u",
    "2025 top iptv", "2026 iptv", "2025 best iptv app", "2025 best iptv box", "iptv 3mu",
    "iptv 3mu player", "3mu iptv", "365 iptv apk", "3u iptv", "3mu iptv player", "3d iptv player",
    "iptv 4k dolby atmos", "iptv 4k apk", "iptv 4k amazon", "iptv 4k boulanger", "iptv 4k reddit",
    "iptv 4g", "4k iptv", "4k iptv player", "4k iptv apk", "4k iptv box", "4k iptv player apk",
    "4k iptv app", "4k live iptv reddit", "5g iptv", "5g iptv apk", "5g live iptv",
    "5g live iptv free username and password", "5g international iptv apk download",
    "5g international iptv كود تفعيل", "5g iptv fiyat", "5g next iptv apk", "5g iptv download",
    "5g international iptv apk تحميل", "iptv 7sur7", "iptv 7 dias grátis", "8k iptv box",
    "iptv 9xtream", "iptv 9xtream ne fonctionne plus", "iptv x96q pro", "iptv x96 pro",
    "iptv x96q avis", "iptv x9", "iptv 9xtream pc", "9xtream iptv", "9xtream iptv code",
    "9xtream iptv ne fonctionne plus", "download xtream iptv", "9xtream iptv pc",
    "9xtream iptv for windows", "9xtream iptv apk download", "xtream player iptv",
    "9xtream iptv premium apk", "9xtream iptv mod apk"
];

export default function SEOKeywords() {
    const [isExpanded, setIsExpanded] = useState(false);
    
    // Show only first 20 keywords initially
    const visibleKeywords = isExpanded ? keywords : keywords.slice(0, 20);

    return (
        <section className="py-12 bg-black border-t border-gray-900">
            <div className="container mx-auto px-4">
                <h3 className="text-xl font-bold text-white mb-6 flex items-center">
                    <span className="w-1 h-6 bg-yellow-400 mr-3 rounded-full"></span>
                    Recherches Populaires
                </h3>
                
                <div className="flex flex-wrap gap-2">
                    {visibleKeywords.map((keyword, index) => (
                        <Link 
                            key={index}
                            to={`/blog`}
                            className="text-xs text-gray-500 hover:text-yellow-400 transition-colors cursor-pointer bg-gray-900/50 px-3 py-1.5 rounded-full border border-gray-800 hover:border-yellow-400/30 block"
                            title={`Recherche : ${keyword}`}
                        >
                            {keyword}
                        </Link>
                    ))}
                </div>
                
                <div className="mt-6 text-center">
                    <button 
                        onClick={() => setIsExpanded(!isExpanded)}
                        className="text-sm text-yellow-400 hover:text-yellow-300 font-medium flex items-center justify-center mx-auto gap-2"
                    >
                        {isExpanded ? (
                            <>
                                Voir moins
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                </svg>
                            </>
                        ) : (
                            <>
                                Voir plus de recherches ({keywords.length - 20}+)
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </>
                        )}
                    </button>
                </div>
            </div>
        </section>
    );
}
